import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'
import { UserDetailTabType } from '@/types'
import {
  UserSearchConditionsItem,
  defaultUserSearchConditionsItem
} from '@/components/organisms/UserSearchCondition'
import { cloneDeep } from 'lodash'
import {
  UserSearchTableItem,
  defaultUserSearchTableItem
} from '@/components/organisms/UserSearchTable'

export interface ModalUserDetailInterface {
  userId: string
  searchResult?: UserSearchTableItem
  initialActiveTab?: UserDetailTabType
  isTitleLink?: boolean
  searchedConditions?: UserSearchConditionsItem
  displayOldIdAlert?: boolean
  onClickOk?: () => void
  onClickCancel?: (isUpdated: boolean) => void
}

@Module({
  name: 'ModalUserDetailStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalUserDetailStore extends BaseStore {
  _isOpen: boolean = false

  _userId: string = ''

  _searchResult: UserSearchTableItem = defaultUserSearchTableItem()

  _initialActiveTab: UserDetailTabType = UserDetailTabType.Basic

  _isTitleLink: boolean = false

  _okCallback?: () => void

  _cancelCallback?: (isUpdated: boolean) => void

  _searchedConditions: UserSearchConditionsItem = defaultUserSearchConditionsItem()

  _displayOldIdAlert: boolean = false

  get isOpen() {
    return this._isOpen
  }

  get userId() {
    return this._userId
  }

  get searchResult() {
    return this._searchResult
  }

  get initialActiveTab(): UserDetailTabType {
    return this._initialActiveTab
  }

  get isTitleLink(): boolean {
    return this._isTitleLink
  }

  get searchedConditions(): UserSearchConditionsItem {
    return this._searchedConditions
  }

  get displayOldIdAlert(): boolean {
    return this._displayOldIdAlert
  }

  @Mutation
  public open(params: ModalUserDetailInterface) {
    this._isOpen = true
    this._userId = params.userId
    this._searchResult = cloneDeep(
      params?.searchResult ?? defaultUserSearchTableItem()
    )
    this._initialActiveTab = params.initialActiveTab ?? UserDetailTabType.Basic
    this._isTitleLink = !!params.isTitleLink
    this._searchedConditions = cloneDeep(
      params?.searchedConditions ?? defaultUserSearchConditionsItem()
    )
    this._displayOldIdAlert = params?.displayOldIdAlert ?? false
    this._okCallback = params.onClickOk
    this._cancelCallback = params.onClickCancel
  }

  @Mutation
  public close() {
    this._isOpen = false
  }

  @Mutation
  public ok() {
    if (this._okCallback !== undefined) {
      this._okCallback()
    }

    this._isOpen = false
  }

  @Mutation
  public cancel(isUpdated: boolean) {
    if (this._cancelCallback !== undefined) {
      this._cancelCallback(isUpdated)
    }

    this._isOpen = false
  }
}
